import { PlayerSegment } from './player-segmentation.interfaces';

export enum CHAT_CHANNEL {
  PORTUGUESSE = 'PORTUGUESSE',
  SPORTS = 'SPORTS',
  CASINO = 'CASINO',
  SONHOS = 'SONHOS',
  DICAS = 'DICAS',
}
export const PUSHER_CHANNEL = 'skljcbwekojfbi3rfhb3irbhg';

export interface IChatMessage {
  _id?: string;
  message: string;
  imageUrl?: string;
  channel: CHAT_CHANNEL;
  user_id: string;
  userName: string;
  userImageUrl?: string;
  timestamp: number;
  likes: number;
  level: PlayerSegment;
  anonymous: boolean;
  gif?: any;
  userBanned?: boolean;
}
